import { render, staticRenderFns } from "./PipelineStageChangeColorModal.vue?vue&type=template&id=34d580d4"
import script from "./PipelineStageChangeColorModal.vue?vue&type=script&lang=js"
export * from "./PipelineStageChangeColorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports